import AffiliateService from '../services/AffiliateService'
import ApproachCatalogService from '../services/ApproachCatalogService'
import ApproachDiscardedService from '../services/ApproachDiscardedService'
import ApproachService from '../services/ApproachService'
import AuthService from '../services/AuthService'
import BillingService from '../services/BillingService'
import BrowserExtensionService from '../services/BrowserExtensionService'
import CampaignApproachService from '../services/CampaignApproachService'
import CampaignCatalogService from '../services/CampaignCatalogService'
import CampaignInvitationPreferencesService from '../services/CampaignInvitationPreferencesService'
import CampaignInvitationService from '../services/CampaignInvitationService'
import CampaignService from '../services/CampaignService'
import CatalogService from '../services/CatalogService'
import CompanyInvitationService from '../services/CompanyInvitationService'
import CompanyNotificationService from '../services/CompanyNotificationService'
import CompanyService from '../services/CompanyService'
import DashboardService from '../services/DashboardService'
import FrequencyService from '../services/FrequencyService'
import InfluencerCategoryService from '../services/InfluencerCategoryService'
import InfluencerOwnershipService from '../services/InfluencerOwnershipService'
import InfluencerPartnershipService from '../services/InfluencerPartnershipService'
import InfluencerPostService from '../services/InfluencerPostService'
import InfluencerService from '../services/InfluencerService'
import IntegrationService from '../services/IntegrationService'
import InvoiceService from '../services/InvoiceService'
import MembershipService from '../services/MembershipService'
import PartnershipApproachService from '../services/PartnershipApproachService'
import PartnershipFormService from '../services/PartnershipFormService'
import PasswordService from '../services/PasswordService'
import ProfileService from '../services/ProfileService'
import ResearchBioService from '../services/ResearchBioService'
import ResearchHashtagPostService from '../services/ResearchHashtagPostService'
import ResearchTaggedPostService from '../services/ResearchTaggedPostService'
import RelatedInfluencerService from '../services/RelatedInfluencerService'
import SkippedApproachService from '../services/SkippedApproachService'
import ViralLinkService from '../services/ViralLinkService'
import WithdrawalSettingsService from '../services/WithdrawalSettingsService'
import WorldService from '../services/WorldService'
import type { $Fetch } from 'ofetch'
import type { ApiServiceContainer } from '../services/ApiServiceContainer'

export default defineNuxtPlugin(async () => {
  const client: $Fetch = useSanctumClient()

  const api: ApiServiceContainer = {
    affiliateService: new AffiliateService(client),
    approachCatalogService: new ApproachCatalogService(client),
    approachDiscardedService: new ApproachDiscardedService(client),
    approachService: new ApproachService(client),
    authService: new AuthService(client),
    billingService: new BillingService(client),
    browserExtensionService: new BrowserExtensionService(client),
    campaignService: new CampaignService(client),
    campaignInvitationPreferencesService: new CampaignInvitationPreferencesService(client),
    campaignInvitationService: new CampaignInvitationService(client),
    campaignApproachService: new CampaignApproachService(client),
    campaignCatalogService: new CampaignCatalogService(client),
    catalogService: new CatalogService(client),
    companyInvitationService: new CompanyInvitationService(client),
    companyNotificationService: new CompanyNotificationService(client),
    companyService: new CompanyService(client),
    dashboardService: new DashboardService(client),
    frequencyService: new FrequencyService(client),
    influencerCategoryService: new InfluencerCategoryService(client),
    influencerOwnershipService: new InfluencerOwnershipService(client),
    influencerPartnershipService: new InfluencerPartnershipService(client),
    influencerPostService: new InfluencerPostService(client),
    influencerService: new InfluencerService(client),
    integrationService: new IntegrationService(client),
    invoiceService: new InvoiceService(client),
    membershipService: new MembershipService(client),
    partnershipApproachService: new PartnershipApproachService(client),
    partnershipFormService: new PartnershipFormService(client),
    passwordService: new PasswordService(client),
    profileService: new ProfileService(client),
    researchBioService: new ResearchBioService(client),
    researchHashtagPostService: new ResearchHashtagPostService(client),
    researchTaggedPostService: new ResearchTaggedPostService(client),
    relatedInfluencerService: new RelatedInfluencerService(client),
    skippedApproachService: new SkippedApproachService(client),
    viralLinkService: new ViralLinkService(client),
    withdrawalSettingsService: new WithdrawalSettingsService(client),
    worldService: new WorldService(client),
  }

  return { provide: { api } }
})
